// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__k1Y84","title":"styles_title__2mw86"};